import { PuzzleFourType } from "../types/PuzzleFourType";
import { PuzzleSixType } from "../types/PuzzleSixDataType";

export default function getImageUrl(
 items: PuzzleFourType[] | PuzzleSixType[], activeId: number | string | null
): string {
    const arr = items.filter((item) => item.id === activeId);
    const url = arr[0].url;
  return url
}